import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';
import { WEB_RTC_CAMERA } from 'actions/chat/webrtc';
import '../styles/chooseCamera.scss';

const chooseCamera = ({
  onChoose,
  onCancel,
  modalProps,
  prefered,
  question,
  front,
  back,
  cancel
}) => (
  <B.Modal {...modalProps}>
    <B.Modal.Body className="chat-webrtc-choosecamera-question">{question}</B.Modal.Body>
    <B.Modal.Footer>
      <B.Button className="chat-webrtc-choosecamera-btn"
        bsStyle={prefered === WEB_RTC_CAMERA.frontal ? "primary" : undefined}
        onClick={onChoose.bind(null, WEB_RTC_CAMERA.frontal)}
      >{front}</B.Button>
      <B.Button className="chat-webrtc-choosecamera-btn"
        bsStyle={prefered === WEB_RTC_CAMERA.main ? "primary" : undefined}
        onClick={onChoose.bind(null, WEB_RTC_CAMERA.main)}
      >{back}</B.Button>
      <B.Button className="chat-webrtc-choosecamera-btn" bsStyle="warning" onClick={onCancel}>
        {cancel}
      </B.Button>
    </B.Modal.Footer>
  </B.Modal>
);

chooseCamera.propTypes = {
  onChoose: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  prefered: PropTypes.string,
  question: PropTypes.string.isRequired,
  front: PropTypes.string.isRequired,
  back: PropTypes.string.isRequired,
  cancel: PropTypes.string.isRequired,
};

export default chooseCamera;



// WEBPACK FOOTER //
// ./components/chat/webrtc/chooseCamera.js